import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import StarIcon from "@mui/icons-material/Star";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";

function ActionsMenu({
  row,
  showEdit,
  showDelete,
  showProductStatus,
  showMegaDiscount,
  showFeaturedStatus,
  showVerifiedStatus,
  showPromotedStatus,
  handleEdit,
  handleDelete,
  handleChangeProductStatus,
  handleChangeFeaturedStatus,
  handleChangeMegaDiscountStatus,
  handleChangeVerifiedStatus,
  handleChangePromotedStatus,
  }) {
  const { t } = useTranslation(["common"]);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <IconButton size="small" onClick={handleOpen}>
        <MoreHorizIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: 240,
            borderRadius: 2,
            mt: 0.5,
          },
        }}
      >
        {showEdit && (
          <MenuItem
            onClick={() => {
              handleEdit(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("edit")}</ListItemText>
          </MenuItem>
        )}

        {(showEdit || showProductStatus) && <Divider />}

        {showProductStatus && (
          <MenuItem disableRipple>
            <ListItemIcon>
              <ToggleOnIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>{t("status")}</ListItemText>

            <Switch
              size="small"
              checked={row.status}
              onChange={(e) =>
                handleChangeProductStatus(
                  e.target.checked,
                  row
                )
              }
            />
          </MenuItem>
        )}

        {showVerifiedStatus && (
          <MenuItem disableRipple>
            <ListItemIcon>
              <ToggleOnIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>{t("verified")}</ListItemText>

            <Switch
              size="small"
              checked={row.isVerified}
              onChange={(e) =>
                handleChangeVerifiedStatus(
                  e.target.checked,
                  row
                )
              }
            />
          </MenuItem>
        )}

        {showFeaturedStatus && (
          <MenuItem disableRipple>
            <ListItemIcon>
              <StarIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>{t("featured")}</ListItemText>

            <Switch
              size="small"
              checked={row.isFeatured}
              onChange={(e) =>
                handleChangeFeaturedStatus(
                  e.target.checked,
                  row
                )
              }
            />
          </MenuItem>
        )}
        
        {showMegaDiscount && (
          <MenuItem disableRipple>
            <ListItemIcon>
              <LocalOfferIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>
              {t("megaDiscount")}
            </ListItemText>

            <Switch
              size="small"
              checked={row.isMegaDiscount}
              onChange={(e) =>
                handleChangeMegaDiscountStatus(
                  e.target.checked,
                  row
                )
              }
            />
          </MenuItem>
        )}

        {showPromotedStatus && (
          <MenuItem disableRipple>
            <ListItemIcon>
              <StarIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>
              {t("promoted")}
            </ListItemText>

            <Switch
              size="small"
              checked={row.isPromoted}
              onChange={(e) =>
                handleChangePromotedStatus(
                  e.target.checked,
                  row
                )
              }
            />
          </MenuItem>
        )}

        {showDelete && (
          <>
            <Divider />

            <MenuItem
              onClick={() => {
                handleDelete(row);
                handleClose();
              }}
              sx={{ color: "error.main" }}
            >
              <ListItemIcon>
                <DeleteIcon
                  fontSize="small"
                  color="error"
                />
              </ListItemIcon>

              <ListItemText>
                {t("delete")}
              </ListItemText>
            </MenuItem>
          </>
        )}
      </Menu>
    </Box>
  );
}

export default ActionsMenu;